import { defineStore } from 'pinia'
import {
  getAllCarouselItems,
  createCarouselItem,
  updateCarouselItem,
  deleteCarouselItem,
  reorderCarouselItems
} from '../api/homepage.service'

export const useHomepageStore = defineStore('homepage', {
  state: () => ({
    carouselItems: [],
    isLoading: false
  }),

  getters: {
    sortedCarouselItems: (state) => {
      return [...state.carouselItems].sort((a, b) => a.orderIndex - b.orderIndex)
    },
    activeCarouselItems: (state) => {
      return state.carouselItems
        .filter(item => item.isActive)
        .sort((a, b) => a.orderIndex - b.orderIndex)
    }
  },

  actions: {
    async fetchAllCarouselItems() {
      this.isLoading = true
      try {
        const data = await getAllCarouselItems()
        this.carouselItems = data
        return data
      } catch (error) {
        console.error('Ошибка загрузки карусели:', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async createItem(item) {
      const newItem = await createCarouselItem(item)
      await this.fetchAllCarouselItems()
      return newItem
    },

    async updateItem(id, item) {
      await updateCarouselItem(id, item)
      await this.fetchAllCarouselItems()
    },

    async deleteItem(id) {
      await deleteCarouselItem(id)
      await this.fetchAllCarouselItems()
    },

    async reorderItems(itemOrders) {
      await reorderCarouselItems(itemOrders)
      await this.fetchAllCarouselItems()
    }
  }
})